<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    :title="title"
    content-class="LKPublicationsFormdataReportModal"
    @closed="$emit('closed')"
  >
    <LKPublicationsFormdataReport
      :params="params"
      :report-code="reportCode"
    />
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer from './LKPublicationsFormdataListModalContainer.vue'
import LKPublicationsFormdataReport from './LKPublicationsFormdataReport.vue'


export default {
  name: 'LKPublicationsFormdataListModal',
  components: {
    LKPublicationsFormdataListModalContainer,
    LKPublicationsFormdataReport,
  },
  inheritAttrs: false,
  props: {
    reportCode: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataReportModal {
  width: 1024px;
  margin-right: auto;
  margin-left: auto;
}
</style>
